import {firebaseStorage, storageRef} from "../../firebase/client-app";
import {deleteObject} from "firebase/storage";
import {UPLOADED_IMAGES_PATH} from "../../common/constants/image.constant";
import {uploadBytes, uploadString} from "@firebase/storage";

export {
    uploadSingleImageFile,
}

const uploadSingleImageFile = (fullFilePath, imageBase64Data, metaData) => {
    const fileReference = storageRef(firebaseStorage, fullFilePath);
    return uploadString(fileReference, imageBase64Data, 'data_url', metaData);
}

